import React from 'react';
import { PawPrintIcon, LeafIcon, WavesIcon, CatIcon, BirdIcon, FishIcon } from 'lucide-react';
export interface ProductCardProps {
  name: string;
  price: number;
  category: string;
  badge?: string;
  badgeType?: 'blue' | 'green' | 'warm';
  memberPrice?: number;
  imageColor: 'blue' | 'green';
  iconType: 'dog' | 'cat' | 'bird' | 'fish' | 'garden' | 'pool' | 'small-animal';
  onNavigate?: (page: 'product') => void;
}
export function ProductCard({
  name,
  price,
  category,
  badge,
  badgeType = 'blue',
  memberPrice,
  imageColor,
  iconType,
  onNavigate
}: ProductCardProps) {
  const getIcon = () => {
    switch (iconType) {
      case 'dog':
        return <PawPrintIcon className="w-12 h-12 text-brand-blue-300" data-id="element-660" />;
      case 'cat':
        return <CatIcon className="w-12 h-12 text-brand-blue-300" data-id="element-661" />;
      case 'bird':
        return <BirdIcon className="w-12 h-12 text-brand-green-300" data-id="element-662" />;
      case 'fish':
        return <FishIcon className="w-12 h-12 text-brand-blue-300" data-id="element-663" />;
      case 'garden':
        return <LeafIcon className="w-12 h-12 text-brand-green-300" data-id="element-664" />;
      case 'pool':
        return <WavesIcon className="w-12 h-12 text-brand-blue-300" data-id="element-665" />;
      case 'small-animal':
        return <PawPrintIcon className="w-12 h-12 text-brand-green-300" data-id="element-666" />;
      default:
        return <PawPrintIcon className="w-12 h-12 text-brand-blue-300" data-id="element-667" />;
    }
  };
  const bgColorClass = imageColor === 'blue' ? 'bg-brand-blue-50' : 'bg-brand-green-50';
  const badgeClass = badgeType === 'blue' ? 'badge-blue' : badgeType === 'green' ? 'badge-green' : 'badge-warm';
  return <div className="card-interactive flex flex-col h-full cursor-pointer group" onClick={() => onNavigate && onNavigate('product')} data-id="element-668">
      <div className={`relative w-full aspect-square ${bgColorClass} rounded-t-2xl flex items-center justify-center overflow-hidden`} data-id="element-669">
        {badge && <div className="absolute top-3 right-3 z-10" data-id="element-670">
            <span className={badgeClass} data-id="element-671">{badge}</span>
          </div>}
        <div className="transition-transform duration-300 group-hover:scale-110" data-id="element-672">
          {getIcon()}
        </div>
      </div>

      <div className="p-5 flex flex-col flex-grow" data-id="element-673">
        <span className="text-xs text-gray-500 mb-1 font-medium uppercase tracking-wider" data-id="element-674">
          {category}
        </span>
        <h3 className="font-heading font-semibold text-gray-900 text-base line-clamp-2 mb-3 flex-grow leading-tight" data-id="element-675">
          {name}
        </h3>

        <div className="mt-auto mb-4" data-id="element-676">
          <div className="text-xl font-bold text-brand-blue" data-id="element-677">
            ${price.toFixed(2)}
          </div>
          {memberPrice && <div className="text-sm font-semibold text-brand-green mt-0.5" data-id="element-678">
              ${memberPrice.toFixed(2)} for members
            </div>}
        </div>

        <button className="btn-primary w-full py-2.5 text-sm" onClick={e => {
        e.stopPropagation();
        // In a real app, this would open an enquiry modal
      }} data-id="element-679">
          Check Availability
        </button>
      </div>
    </div>;
}